import axios from './axios-instance'

export default {
  all ({ q = '', page = 1, limit = 20, tutorialType = '' }) {
    return axios.get(`v1/tutorials?tutorial_type=${tutorialType}&limit=${limit}&page=${page}&q=${q}`)
  }
}
